import React from 'react';
import styled from 'styled-components';
import { ChangePasswordForm } from '../../profile/form/ChangePasswordForm';


type ChangePasswordModalProps = {
  title?: string;
  message?: string;
  icon?: string;
};

const ModalWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
`

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({title, message, icon}) => {

  return (
    <ModalWrapper>
      <ChangePasswordForm/>
    </ModalWrapper>
  );
};
